<div class="heavy-tasks-btn-group">
    @for (item of items; track item) {
        <button type="button" class="btn" [ngClass]="{ 'btn-primary': value === item }" [disabled]="disable" (click)="select(item)">
            {{ item === null ? ('NO_LIMIT' | translate) : item }}
        </button>
    }
</div>
